import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';
import { SessionDataService } from '../../service/session-data.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-page-details-dialog',
  templateUrl: './page-details-dialog.component.html',
  styleUrls: ['./page-details-dialog.component.css']
,
  standalone: false
})
export class PageDetailsDialogComponent implements OnInit {
  displayedColumns: string[] = ['timeStamp', 'pageType', 'subType', 'siteName', 'eventLink'];
  dataSource = new MatTableDataSource<any>([]);
  length = 0;
  pageSize = 10;
  pageIndex = 0;
  apiData:any;

  constructor(
    public dialogRef: MatDialogRef<PageDetailsDialogComponent>,
    private sessionDataService: SessionDataService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData(event?: PageEvent): void {
    const page = event ? event.pageIndex : this.pageIndex;
    const size = event ? event.pageSize : this.pageSize;
    //const url = `http://user-activity.pro-vigil.info:8080/useractivity/byid?sessionid=${this.data.sessionId}&page=${page}&size=${size}`;
    
    // this.http.get<any>(url).subscribe(response => {
    //   this.dataSource = response.data.content;
    //   this.length = response.data.totalElements;
    // });
    let payload = {
        sessionId: this.data?.sessionId,
        pageIndex: page,
        pageSize: size,
        fromDate: '',
        toDate: ''
    }
    this.sessionDataService.getSessionIdDetails(payload).subscribe(response => {
        this.dataSource.data = response.content ?? [];
        this.apiData = response;
        // this.dataSource = new MatTableDataSource<any>([
        //     {
        //         "id": "669808340f6bc90b9f2ca804",
        //         "footageLink": null,
        //         "subType": "HD View",
        //         "footageType": null,
        //         "timeStamp": "2024-07-17 23:36:44",
        //         "sessionId": "079CBDD6CD2B4202BCB9983C84D7F648",
        //         "username": "gabriela.lester@sheaproperties.com",
        //         "userType": "Customer",
        //         "pageType": "Live Views",
        //         "siteName": "Shea Properties - Laguna Heights 31-273 F1006",
        //         "potentialId": "720528",
        //         "source": "web",
        //         "additionalInfo": {
        //             "liveViewsName": "F1006 Cam9 Near Baja Fresh and Marina Hills W. entrance",
        //             "hdUrl": "https://apps.pro-vigil.info:8099/api/mp/customer/720528/Camera152"
        //         },
        //         "kmeLoggedIn": false
        //     },
        //     {
        //         "id": "669808190f6bc90b9f2ca802",
        //         "footageLink": null,
        //         "subType": "HD View",
        //         "footageType": null,
        //         "timeStamp": "2024-07-17 23:36:17",
        //         "sessionId": "079CBDD6CD2B4202BCB9983C84D7F648",
        //         "username": "gabriela.lester@sheaproperties.com",
        //         "userType": "Customer",
        //         "pageType": "Live Views",
        //         "siteName": "Shea Properties - Laguna Heights 31-273 F1006",
        //         "potentialId": "720528",
        //         "source": "web",
        //         "additionalInfo": {
        //             "liveViewsName": "F1006 Cam12 Starbucks Courtyard/Seating Area",
        //             "hdUrl": "https://apps.pro-vigil.info:8099/api/mp/customer/720528/Camera155"
        //         },
        //         "kmeLoggedIn": false
        //     },
        //     {
        //         "id": "669807eb0f6bc90b9f2ca7f8",
        //         "footageLink": null,
        //         "subType": "HD View",
        //         "footageType": null,
        //         "timeStamp": "2024-07-17 23:35:31",
        //         "sessionId": "079CBDD6CD2B4202BCB9983C84D7F648",
        //         "username": "gabriela.lester@sheaproperties.com",
        //         "userType": "Customer",
        //         "pageType": "Live Views",
        //         "siteName": "Shea Properties - Laguna Heights 31-273 F1006",
        //         "potentialId": "720528",
        //         "source": "web",
        //         "additionalInfo": {
        //             "liveViewsName": "F1006 Cam9 Near Baja Fresh and Marina Hills W. entrance",
        //             "hdUrl": "https://apps.pro-vigil.info:8099/api/mp/customer/720528/Camera152"
        //         },
        //         "kmeLoggedIn": false
        //     },
        //     {
        //         "id": "669807c80f6bc90b9f2ca7ee",
        //         "footageLink": null,
        //         "subType": "Visit",
        //         "footageType": null,
        //         "timeStamp": "2024-07-17 23:34:56",
        //         "sessionId": "079CBDD6CD2B4202BCB9983C84D7F648",
        //         "username": "gabriela.lester@sheaproperties.com",
        //         "userType": "Customer",
        //         "pageType": "Live Views",
        //         "siteName": "Shea Properties - Laguna Heights 31-273 F1006",
        //         "potentialId": "720528",
        //         "source": "web",
        //         "additionalInfo": {
        //             "liveViewsName": "Visit"
        //         },
        //         "kmeLoggedIn": false
        //     }
        // ]);
        this.length = response.totalElements;
    })
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
